import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Nav,
  Button,
  Form,
  Card,
  Dropdown,
  Table,
  Modal,
  Spinner,
  ListGroup,
  ListGroupItem,
  FormCheck,
} from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo,
  faCalendarAlt,
  faTicketAlt,
  faClipboardList,
  faTimes,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Avatar from "react-avatar";
import EventManagerNavbar from "./EventManagerNavbar";
import EventNavbar from "./Navbar";
import EventManagerLeftbar from "./EventManagerLeftbar";
import firebase from "firebase";
import {
  useHistory,
  useLocation,
  withRouter,
  useParams,
} from "react-router-dom";
import { useCollection, useDocument } from "react-firebase-hooks/firestore";
import { sendEmail } from "../../../utils/index";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { languageText as languageTextToast } from "./language.json";
import BoothCategory from "./BoothCategory";
import DraggableList from "./DraggableList";
import { connect } from "react-redux";
import _ from "lodash";
import produce from "immer";
toast.configure();

toast.configure();

const Booths = (props) => {
  const [eventSnapshot, loadingEvent, errorEvent] = useDocument(
    firebase.firestore().collection("courses").doc("hdCKh1GocgVH6v2zLaGn")
  );
  const showFullCardBooths =
    eventSnapshot?.data()?.show_full_card_booths ?? false;
  const boothChatEnabled = eventSnapshot?.data().booth_chat_enabled ?? false;
  const boothMeetNowEnabled =
    eventSnapshot?.data().booth_meet_now_enabled ?? false;

  const history = useHistory();
  const [showAddBoothOwnerModal, setShowAddBoothOwnerModal] = useState(false);
  const [email, setEmail] = useState([""]);
  const [snapshot, loading, error] = useCollection(
    firebase.firestore().collection("/courses/hdCKh1GocgVH6v2zLaGn/booths")
  ); //listens to onsnapshot changes
  const [categorySnapshot, loadingCategory, errorCategory] = useCollection(
    firebase
      .firestore()
      .collection("/courses/hdCKh1GocgVH6v2zLaGn/boothCategories")
      .orderBy("order_index", "asc")
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showReorderCategory, setShowReorderCategory] = useState(false);
  const [showReorderBooths, setShowReorderBooths] = useState(false);

  //assigning categories states
  const [showAssignCategories, setShowAssignCategories] = useState(false);
  const [selectedBoothUID, setSelectedBoothUID] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [assigning, setAssigning] = useState(false);

  const { currentLanguage } = props;

  const [showAddCategory, setShowAddCategory] = useState(false);
  const emptyIndexInArrayHandler = (array) => {
    const resultArray = array.map((email) => {
      if (email.trim().length) {
        return 0;
      } else {
        return 1;
      }
    });
    return resultArray.reduce((a, b) => a + b, 0);
  };

  // use below function for assigning multiple categories to a booth
  // const assignedCategoryChangeHandler = (categoryID) => {
  //   const index = selectedCategories.findIndex(
  //     (category) => category === categoryID
  //   );

  //   if (index !== -1) {
  //     // category already exists
  //     // so removing it
  //     const updatedSelectedCategories = produce(selectedCategories, (draft) => {
  //       draft.splice(index, 1);
  //     });
  //     setSelectedCategories(updatedSelectedCategories);
  //   } else {
  //     // add category
  //     const updatedSelectedCategories = produce(selectedCategories, (draft) => {
  //       draft.push(categoryID);
  //     });
  //     setSelectedCategories(updatedSelectedCategories);
  //   }
  // };

  // use below function for single category to a booth
  const assignedCategoryChangeHandler = (categoryID) => {
    const index = selectedCategories.findIndex(
      (category) => category === categoryID
    );

    if (index !== -1) {
      // category already exists
      // so removing it
      const updatedSelectedCategories = produce(selectedCategories, (draft) => {
        draft.pop();
      });
      setSelectedCategories(updatedSelectedCategories);
    } else {
      // add category
      const updatedSelectedCategories = produce(selectedCategories, (draft) => {
        draft.pop();
        draft.push(categoryID);
      });
      setSelectedCategories(updatedSelectedCategories);
    }
  };

  const addBoothOwnerHandler = (e, email) => {
    e.preventDefault();
    if (!emptyIndexInArrayHandler(email)) {
      try {
        firebase
          .firestore()
          .collection("/courses/hdCKh1GocgVH6v2zLaGn/booths")
          .doc()
          .set({
            email_address_of_owner: email,
            user_role: 2,
            timestamp_of_assigning: new Date().valueOf(),
          })
          .then(() => {
            email.forEach((em) => {
              sendEmail({
                to: em,
                subject:
                  "You are invited to manage your booth at Blue Ocean Awards",
                content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/BOA.png" alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi,</span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">You are invited to manage your booth at Blue Ocean Awards - 7th Edition. </span></p><p style="font-size: 14px; line-height: 140%;"> <br /> <span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">Please register as a visitor using the <strong style="background-color: #FFF000;">same email address</strong> where you are recieving this email invite. </span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://courses.igesia.co/event/template/register/${em}" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Manage Booth</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--><p style="font-size: 14px; line-height: 140%; margin-top:30px"> <br /> Please write to <a href="mailto:support@igesia.co"> support@igesia.co</a> for assistance. <br /></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://courses.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
                from: '"igesia" <noreply@igesia.co>',
              });
            });
          });
      } catch (e) {
        console.error(e, "unable to write to db");
      } finally {
        setEmail([""]);
        setShowAddBoothOwnerModal(false);
      }
    } else {
      //set error email is empty
      toast.error(languageTextToast[`${currentLanguage}`].emailEmptyInBooth, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    }
  };

  const addBoothOwnerEmailInArray = () => {
    const prevEmails = [...email];
    prevEmails.push("");
    setEmail(prevEmails);
  };

  const removeEmailFromArrayHandler = (index) => {
    setEmail((prev) => {
      const filteredArray = prev.filter((email, i) => i !== index);
      setEmail(filteredArray);
    });
  };

  const addEmailIdInArray = (index, value) => {
    const prevEmails = [...email];
    prevEmails.splice(index, 1, value);
    setEmail(prevEmails);
  };

  const sendReminder = async (email) => {
    email.forEach(async (em) => {
      const response = await sendEmail({
        to: em,
        subject: "You are invited to manage your booth at Blue Ocean Awards",
        content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/BOA.png" alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi,</span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">You are invited to manage your booth at Blue Ocean Awards - 7th Edition. </span></p><p style="font-size: 14px; line-height: 140%;"> <br /> <span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">Please register as a visitor using the <strong style="background-color: #FFF000;">same email address</strong> where you are recieving this email invite. </span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://courses.igesia.co/event/template/register/${em}" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Manage Booth</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--><p style="font-size: 14px; line-height: 140%; margin-top:30px"> <br /> Please write to <a href="mailto:support@igesia.co"> support@igesia.co</a> for assistance. <br /></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://courses.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
        from: '"igesia" <noreply@igesia.co>',
      });
      if (response.status === 200) {
        toast.success("Reminder sent successfully", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
      }
    });
  };

  const sortedCategories = categorySnapshot?.docs.map((category) => ({
    ...category.data(),
    id: category.id,
  }));

  // adding "all category"

  const sortedCategoriesWithAll = sortedCategories ? [...sortedCategories] : [];
  sortedCategoriesWithAll?.unshift({
    EN: {
      title: "All",
    },
    FR: {
      title: "All",
    },
    id: "all",
  });

  const assignBoothCategoryHandler = async (uid) => {
    try {
      setAssigning(true);
      await firebase
        .firestore()
        .collection("/courses/hdCKh1GocgVH6v2zLaGn/booths/")
        .doc(uid)
        .update({
          booth_categories: selectedCategories,
        });
      toast.success("Category assigned to booth", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } catch (e) {
      toast.error("Error assigning category to booth", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } finally {
      setAssigning(false);
      setSelectedCategories([]);
      setSelectedBoothUID(null);
      setShowAssignCategories(false);
    }
  };

  // reoder category
  // throttling
  const listReorderHandler = (newOrder) => {
    // new order will be an array of indices
    newOrder.forEach((order, index) => {
      // [1,0,3,2]
      if ((order !== undefined || order !== null) && sortedCategories.length) {
        sortedCategories[order].order_index = index;
      }
    });
  };
  const saveOrderIndexToDBHandler = async () => {
    try {
      sortedCategories.forEach(async (category) => {
        await firebase
          .firestore()
          .collection("/courses/hdCKh1GocgVH6v2zLaGn/boothCategories/")
          .doc(category.id)
          .update({
            order_index: category.order_index,
          });
      });
      toast.success("Booth categories reordered!", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } catch (e) {
      console.error(e, "error in changing the order");
    }
  };

  const throttledReorder = _.throttle(listReorderHandler, 1000);

  // reoder category
  // throttling
  const listReorderHandlerBooths = (newOrder) => {
    // new order will be an array of indices
    newOrder.forEach((order, index) => {
      // [1,0,3,2]
      if (
        (order !== undefined || order !== null) &&
        currentCategoryBooths.length
      ) {
        currentCategoryBooths[order].order_index = index;
      }
    });
  };
  const saveOrderIndexToDBHandlerBooths = async () => {
    try {
      currentCategoryBooths.forEach(async (booth) => {
        await firebase
          .firestore()
          .collection("/courses/hdCKh1GocgVH6v2zLaGn/booths/")
          .doc(booth.id)
          .update({
            order_index: booth.order_index,
          });
      });
      toast.success("Booths reordered!", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } catch (e) {
      console.error(e, "error in changing the order");
    }
  };

  const throttledReorderBooths = _.throttle(listReorderHandlerBooths, 1000);

  let currentCategoryBooths = snapshot?.docs.map((booth) => {
    if (!currentIndex) {
      return {
        ...booth.data(),
        id: booth.id,
      };
    } else {
      if (
        booth.data().booth_categories &&
        booth.data().booth_categories.length &&
        booth
          .data()
          .booth_categories.includes(sortedCategoriesWithAll[currentIndex].id)
      ) {
        return {
          ...booth.data(),
          id: booth.id,
        };
      }
    }
  });
  currentCategoryBooths = currentCategoryBooths?.filter((category) => category);
  currentCategoryBooths = _.orderBy(
    currentCategoryBooths,
    "order_index",
    "asc"
  );

  if (loading) return <Spinner size="sm" animation="border" />;
  if (error) return <h5>Something went wrong!</h5>;

  return (
    <>
      <div
        className="container-fluid h-100 pb-4 text-light"
        style={{ overflow: "hidden" }}
      >
        <div className="col-md-12 h-100 mt-3 text-light">
          <h5>Booth Management</h5>
          <div className="mt-3">
            <div className="d-flex align-items-center justify-content-between">
              <Dropdown>
                <Dropdown.Toggle variant="dark" id="dropdown-basic" size="sm">
                  All courses
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Blue Ocean Awards: 7th Edition</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column align-items-center mr-2">
                  <span className="text-secondary small font-weight-bold">
                    FULL CARD BOOTHS
                  </span>
                  <span>
                    <FormCheck
                      type="switch"
                      id="custom-switch-booths"
                      label={showFullCardBooths ? "On" : "Off"}
                      checked={showFullCardBooths}
                      onChange={(e) =>
                        firebase
                          .firestore()
                          .collection("courses")
                          .doc("hdCKh1GocgVH6v2zLaGn")
                          .update({
                            show_full_card_booths: e.target.checked,
                          })
                      }
                    ></FormCheck>
                  </span>
                </div>
                <div className="d-flex flex-column align-items-center mr-2">
                  <span className="text-secondary small font-weight-bold">
                    BOOTH MEET NOW
                  </span>
                  <span>
                    <FormCheck
                      type="switch"
                      id="custom-switch-booths-meet-now"
                      label={boothMeetNowEnabled ? "On" : "Off"}
                      checked={boothMeetNowEnabled}
                      onChange={(e) =>
                        firebase
                          .firestore()
                          .collection("courses")
                          .doc("hdCKh1GocgVH6v2zLaGn")
                          .update({
                            booth_meet_now_enabled: e.target.checked,
                          })
                      }
                    ></FormCheck>
                  </span>
                </div>
                <div className="d-flex flex-column align-items-center mr-2">
                  <span className="text-secondary small font-weight-bold">
                    BOOTH CHAT
                  </span>
                  <span>
                    <FormCheck
                      type="switch"
                      id="custom-switch-booths-chat"
                      label={boothChatEnabled ? "On" : "Off"}
                      checked={boothChatEnabled}
                      onChange={(e) =>
                        firebase
                          .firestore()
                          .collection("courses")
                          .doc("hdCKh1GocgVH6v2zLaGn")
                          .update({
                            booth_chat_enabled: e.target.checked,
                          })
                      }
                    ></FormCheck>
                  </span>
                </div>
                <Button
                  className="btn-sm btn-primary mr-2"
                  onClick={() => setShowAddBoothOwnerModal(true)}
                >
                  Add booth
                </Button>
                <Button
                  className="btn-sm btn-primary mr-2"
                  onClick={() => setShowAddCategory(true)}
                >
                  Add category
                </Button>
                {currentIndex ? (
                  <Button
                    className="btn-sm btn-secondary mr-2"
                    onClick={() => setShowReorderBooths(true)}
                    // disabled={true}
                  >
                    Reorder booths
                  </Button>
                ) : null}
                <Button
                  className="btn-sm btn-secondary mr-2"
                  onClick={() => setShowReorderCategory(true)}
                  // disabled={true}
                >
                  Reorder category
                </Button>

                <Button className="btn-sm btn-primary mr-2 disabled">
                  Email booth admins
                </Button>
              </div>
            </div>
            <div className="w-100 d-flex justify-content-between bg-dark text-light my-3">
              <ListGroup horizontal className="w-100 overflow-auto">
                {sortedCategoriesWithAll?.map((category, index) => {
                  return (
                    <ListGroupItem
                      onClick={(e) => {
                        setCurrentIndex(index);
                      }}
                      style={{ cursor: "pointer" }}
                      active={currentIndex === index}
                      className={
                        currentIndex === index
                          ? "bg-primary border-0"
                          : "bg-dark border-0"
                      }
                    >
                      <p
                        className="mb-0"
                        // eventKey={category[currentLanguage].title}
                      >
                        {category[currentLanguage].title}
                      </p>
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            </div>
            <div
              className="mt-3 mb-5 pb-5 overflow-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="h-100">
                <Table borderless responsive className="text-light">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Email of owner</th>
                      <th>Booth created ? </th>
                    </tr>
                  </thead>
                  <tbody>
                    {snapshot &&
                      snapshot.docs.map((booth, index) => {
                        if (!currentIndex) {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                {booth.data().email_address_of_owner &&
                                  booth
                                    .data()
                                    .email_address_of_owner.map((item, key) => (
                                      <p className="mb-0" key={key}>
                                        {item}
                                      </p>
                                    ))}
                              </td>
                              <td>{booth.data().booth_name ? "Yes" : "No"}</td>
                              <td>
                                <div className="d-flex flex-column justify-content-between align-items-center">
                                  <Button
                                    variant="secondary"
                                    onClick={() => {
                                      setSelectedBoothUID(booth.id);
                                      setShowAssignCategories(true);
                                      if (
                                        booth.data().booth_categories &&
                                        booth.data().booth_categories.length
                                      ) {
                                        setSelectedCategories((prev) => {
                                          const newState = [
                                            ...booth.data().booth_categories,
                                          ];
                                          return newState;
                                        });
                                      }
                                    }}
                                    className="btn-sm mt-2"
                                  >
                                    Assign category
                                  </Button>
                                  {!booth.data().booth_name ? (
                                    <Button
                                      variant="primary"
                                      onClick={() =>
                                        sendReminder(
                                          booth.data().email_address_of_owner
                                        )
                                      }
                                      className="btn-sm mt-1"
                                    >
                                      Send reminder
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="secondary"
                                      onClick={() =>
                                        history.push(
                                          `/event/template/previewbooth/${booth.id}`
                                        )
                                      }
                                      className="btn-sm mt-1"
                                    >
                                      Preview booth
                                    </Button>
                                  )}
                                  <Button
                                    variant="outline-danger"
                                    className="btn btn-sm"
                                    onClick={() =>
                                      history.push(
                                        `/event/template/managebooth/${booth.id}`
                                      )
                                    }
                                    className="btn-sm mt-1"
                                  >
                                    Edit booth
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      })}
                    {currentIndex ? (
                      <>
                        {currentCategoryBooths &&
                          currentCategoryBooths.map((booth, index) => {
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>
                                  {booth.email_address_of_owner &&
                                    booth.email_address_of_owner.map(
                                      (item, key) => (
                                        <p className="mb-0" key={key}>
                                          {item}
                                        </p>
                                      )
                                    )}
                                </td>
                                <td>{booth.booth_name ? "Yes" : "No"}</td>
                                <td>
                                  <div className="d-flex flex-column justify-content-between align-items-center">
                                    <Button
                                      variant="secondary"
                                      onClick={() => {
                                        setSelectedBoothUID(booth.id);
                                        setShowAssignCategories(true);
                                        if (
                                          booth.booth_categories &&
                                          booth.booth_categories.length
                                        ) {
                                          setSelectedCategories((prev) => {
                                            const newState = [
                                              ...booth.booth_categories,
                                            ];
                                            return newState;
                                          });
                                        }
                                      }}
                                      className="btn-sm mt-2"
                                    >
                                      Assign category
                                    </Button>
                                    {!booth.booth_name ? (
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          sendReminder(
                                            booth.email_address_of_owner
                                          )
                                        }
                                        className="btn-sm mt-1"
                                      >
                                        Send reminder
                                      </Button>
                                    ) : null}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </>
                    ) : null}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* modal for add ticket */}

      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showAddBoothOwnerModal}
        onHide={() => setShowAddBoothOwnerModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add booth
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <Form.Group className="col-md-12">
                <Form.Label className="small">
                  Add emails of booth administrators. We will send them an
                  invite link to design their booth.
                </Form.Label>
                {email &&
                  email.map((em, index) => (
                    <div className="d-flex align-items-center mt-3" key={index}>
                      <Form.Control
                        value={email[index]}
                        onChange={(e) =>
                          addEmailIdInArray(index, e.target.value)
                        }
                        type="email"
                        placeholder="Email"
                      />
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="red"
                        className="mx-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => removeEmailFromArrayHandler(index)}
                      ></FontAwesomeIcon>
                    </div>
                  ))}
                <Button
                  variant="outline"
                  className="btn-sm btn-outline-primary mx-auto my-3"
                  onClick={addBoothOwnerEmailInArray}
                >
                  Add email
                </Button>
              </Form.Group>
            </div>
            <Button
              variant="primary"
              className="w-100"
              onClick={(e) => addBoothOwnerHandler(e, email)}
              type="submit"
            >
              Send Invite
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* reorder category */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showReorderCategory}
        onHide={() => setShowReorderCategory(false)}
      >
        <Modal.Header closeButton>Reorder categories</Modal.Header>
        <Modal.Body>
          <DraggableList
            orderFunction={throttledReorder}
            items={sortedCategories}
            variant="categoriesMultiLang"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            className="btn-sm"
            onClick={() => setShowReorderCategory(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="btn-sm"
            onClick={() => {
              saveOrderIndexToDBHandler();
              setShowReorderCategory(false);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* reorder booths */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showReorderBooths}
        onHide={() => setShowReorderBooths(false)}
      >
        <Modal.Header closeButton>Reorder Booths</Modal.Header>
        <Modal.Body>
          <DraggableList
            orderFunction={throttledReorderBooths}
            items={currentCategoryBooths}
            variant="booths"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            className="btn-sm"
            onClick={() => setShowReorderBooths(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="btn-sm"
            onClick={() => {
              saveOrderIndexToDBHandlerBooths();
              setShowReorderBooths(false);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal assign category */}

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showAssignCategories}
        onHide={() => {
          setSelectedBoothUID(null);
          setShowAssignCategories(false);
          setSelectedCategories([]);
        }}
      >
        <Modal.Header closeButton>Assign Category</Modal.Header>
        <Modal.Body>
          {sortedCategories?.map((category, index) => {
            return (
              <Form.Check type="checkbox" id={category + index}>
                <Form.Check.Input
                  type="checkbox"
                  onChange={(e) => {
                    assignedCategoryChangeHandler(category.id);
                  }}
                  checked={selectedCategories.includes(category.id)}
                />
                <Form.Check.Label
                  className="text-dark user-select-none"
                  htmlFor={category + index}
                >
                  {category[currentLanguage].title}
                </Form.Check.Label>
              </Form.Check>
            );
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            className="btn-sm"
            onClick={() => {
              setSelectedBoothUID(null);
              setShowAssignCategories(false);
              setSelectedCategories([]);
            }}
            disabled={assigning}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="btn-sm"
            onClick={() => {
              setShowAssignCategories(false);
              assignBoothCategoryHandler(selectedBoothUID);
            }}
            disabled={assigning}
          >
            {assigning ? <Spinner animation="border" size="sm" /> : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      {showAddCategory ? (
        <BoothCategory
          show={showAddCategory}
          onHide={() => setShowAddCategory(false)}
        />
      ) : null}
    </>
  );
};
export default connect((state) => ({ currentLanguage: state.currentLanguage }))(
  Booths
);
